import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    migrationStartedTitle: {
        id: 'migration.modal.migration_started.title',
        defaultMessage: 'Balances migration started',
    },
    migrationStartedSubtitle: {
        id: 'migration.modal.migration_started.subtitle',
        defaultMessage: 'Check Freewallet migrator interface for status and manage balances as usual after completion',
    },
    migrationStartedButtonText: {
        id: 'migration.modal.migration_started_button.text',
        defaultMessage: 'OK',
    },
})
